import React from "react";

const ArrowDown = () => (
  <svg width="7" height="5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.82 4.843a.3.3 0 00.509 0L6.07.46A.3.3 0 005.816 0H.332a.3.3 0 00-.254.46L2.82 4.842z" fill="#B8BEC8" />
  </svg>
);

export default ArrowDown;
